import { combineReducers } from 'redux';

import selection from './selection.js';
import smallReducers from './smallReducers.js';

export default combineReducers({ selection, ...smallReducers });
